import useHasPermissions from "hooks/useHasPermissions";
import RBACWrapperProps from "./RBACWrapper.types";

function RBACWrapper(props: RBACWrapperProps) {
  const hasPermissions = useHasPermissions(
    props.requiredPermissions,
    props.oneOf
  );

  if (!hasPermissions) {
    return <>{props.fallback}</>;
  }

  return <>{props.children}</>;
}

export default RBACWrapper;
